export function isFigmaPresentationUrl(raw: string): boolean {
  const trimmed = raw.trim();
  if (trimmed === "") return false;
  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol !== "https:" && parsed.protocol !== "http:") return false;
    if (!/(^|\.)figma\.com$/i.test(parsed.hostname)) return false;
    return /^\/(deck|slides|design|file|proto|board)\//i.test(parsed.pathname);
  } catch {
    return false;
  }
}
